var map = {
	"./adobe-ps.svg": "nDYy",
	"./adobe-xd.svg": "JEzv",
	"./agenocrm.png": "Vv5l",
	"./any-do.png": "85+Q",
	"./any-do.svg": "nfQ1",
	"./asana.svg": "FkOE",
	"./assembla.png": "skhA",
	"./automate-io.png": "i5YA",
	"./axosoft.png": "lCQA",
	"./backlog.png": "YSaA",
	"./bambam.png": "cl+6",
	"./basecamp.svg": "60tO",
	"./bitbucket.svg": "fyaC",
	"./bitrix24.svg": "c/T0",
	"./breeze.svg": "LWcP",
	"./bugsnag.svg": "uijl",
	"./capsule-crm.svg": "TUWK",
	"./chrome.png": "JXPS",
	"./clickup.svg": "khbR",
	"./cloudes.png": "1b5E",
	"./cloudwork.png": "dC2z",
	"./codeable.svg": "WiKP",
	"./codebase.png": "Hwr4",
	"./desk.jpg": "pXvS",
	"./deskcom.png": "TZS0",
	"./devdocs.png": "2lDS",
	"./doit.logo.jpg": "Rz6B",
	"./dokuwiki.png": "//+D",
	"./draftin.png": "g1S0",
	"./drupal.svg": "xTTL",
	"./eproject.png": "62zl",
	"./esa.png": "wlNv",
	"./eventum.png": "69e3",
	"./evernote.png": "FnmH",
	"./exana.png": "1VRk",
	"./feedly_logo.png": "Ntpl",
	"./firefox.png": "Kbbr",
	"./flow.png": "ru2S",
	"./flow.svg": "XfMM",
	"./fogbugz.svg": "caKH",
	"./freshdesk.png": "yNBJ",
	"./freshdesk.svg": "KveY",
	"./gingko-app.png": "gJCD",
	"./githuboctocat.svg": "gnQJ",
	"./gitlab.svg": "ZYr/",
	"./gmail.svg": "qJ0p",
	"./gogs.png": "T+Es",
	"./google-calendar.svg": "6Z1G",
	"./google-keep.svg": "rYKU",
	"./googledocs.png": "v5gY",
	"./googledrive.svg": "TDsX",
	"./gotdone.png": "or1u",
	"./gqueues.png": "qSNY",
	"./habitica.png": "tJnT",
	"./habitica.svg": "+L8E",
	"./helpscout.png": "03V2",
	"./helpscout.svg": "Bu0o",
	"./husky.jpg": "yKK9",
	"./ical.png": "eBwE",
	"./integrately.svg": "+4TD",
	"./integrations-balloons.png": "qBPS",
	"./intercom.png": "+wXK",
	"./jira.svg": "/8+V",
	"./jquery.png": "wwi1",
	"./kanbanery.png": "kfXa",
	"./kanbanist.svg": "Fjnb",
	"./kantree.png": "XuEu",
	"./khanacademy.png": "6eN5",
	"./khanacademy.svg": "QmTj",
	"./liquidplanner.png": "woKu",
	"./liveagent.svg": "WkCp",
	"./make.png": "InKO",
	"./mantis-hub.png": "DYtx",
	"./meistertask.svg": "fapr",
	"./microsoft-planner.svg": "gzKf",
	"./microsoft-todo.svg": "l3b0",
	"./minicrm.png": "p2xV",
	"./newsletter2go.png": "UJtS",
	"./notion.svg": "Mb9D",
	"./nozbe.svg": "8QWy",
	"./odoo.svg": "8N/e",
	"./only_office.png": "9SB/",
	"./openproject.svg": "uEEl",
	"./osticket.png": "aUx2",
	"./outlook.svg": "VC2O",
	"./overv.png": "rhb4",
	"./pagerduty.svg": "5Ttg",
	"./phabricator.png": "TWkI",
	"./pivitol.svg": "HLJX",
	"./planbox.png": "1zws",
	"./podio.svg": "fhye",
	"./produck.svg": "kYTD",
	"./producteev.svg": "Bd0b",
	"./protonmail.png": "Q7wt",
	"./redbooth.svg": "xqCy",
	"./redmine.png": "GgA2",
	"./remember-the-milk.png": "DcQn",
	"./rindle.png": "6lRa",
	"./rollbar.png": "rahE",
	"./salesforce.svg": "NFfy",
	"./sentry.png": "UHnP",
	"./sherpadesk.png": "aIR3",
	"./sifter.svg": "8jWf",
	"./slack.png": "V+Jf",
	"./slack.svg": "603+",
	"./smart-board.png": "B1h1",
	"./sourcelair.svg": "5t+x",
	"./spidergap.png": "qNoS",
	"./sprintly.png": "PytU",
	"./taiga.svg": "mPUC",
	"./targetprocess.svg": "FWVg",
	"./teamleader.png": "zyl+",
	"./teamleader.svg": "W2r4",
	"./teamwork.svg": "YE4c",
	"./testrail.png": "1StO",
	"./tick.png": "8bEg",
	"./todoist.png": "WcGF",
	"./toggl-track.svg": "OChM",
	"./toggl.png": "580U",
	"./togglplan.png": "P9VK",
	"./toodledo.png": "gfxM",
	"./tray-io.svg": "A6Qu",
	"./trello.svg": "g8FM",
	"./unfuddle.svg": "ypjG",
	"./visualstudio.svg": "Rl/I",
	"./waffle.svg": "FEyx",
	"./wordpress.svg": "gxB4",
	"./workfront.png": "Msmn",
	"./worksection.svg": "dotJ",
	"./wrike.svg": "EGH9",
	"./xero.svg": "veUf",
	"./youtrack.png": "SN4S",
	"./zapier.svg": "P66I",
	"./zendesk.svg": "P97v",
	"./zoho.png": "KdPw",
	"./zube.png": "6i2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qviY";